module.exports = __webpack_public_path__ + "img/close_red.309db0e4.svg";